import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { PdfValue } from './PdfExport.consts';

export const generatePdf = async (
  valuesArray: PdfValue[],
  templatePath: string,
  pdfName: string
) => {
  const response = await fetch(templatePath);
  const htmlContent = await response.text();

  // Create the hidden div
  const element = document.createElement('div');
  element.innerHTML = htmlContent;
  element.style.position = 'absolute';
  element.style.left = '-9999px'; // Move it off-screen
  element.style.width = `fit-content`;
  element.style.height = 'fit-content';

  document.body.appendChild(element);

  // Fill values dynamically
  valuesArray.forEach((item) => {
    const htmlEl = element.querySelectorAll(item.selector);
    if (htmlEl) htmlEl.forEach((el) => (el.innerHTML = item.value));
  });

  // Capture the element
  const canvas = await html2canvas(element, {
    scale: 2,
  });

  const imgData = canvas.toDataURL('image/png');

  const canvasWidth = canvas.width;
  const canvasHeight = canvas.height;

  const pdf = new jsPDF({
    unit: 'px',
    format: [canvasWidth, canvasHeight],
  });

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  const ratio = Math.min(pdfWidth / canvasWidth, pdfHeight / canvasHeight);
  const imgWidth = canvasWidth * ratio;
  const imgHeight = canvasHeight * ratio;

  pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

  pdf.save(`${pdfName}.pdf`);

  // Remove the temporary element
  document.body.removeChild(element);
};
